import {
  AlarmRecognition,
  DeviceAreaType,
  HomeTransfer,
  HumidityNode,
  NightLight,
  NoiseMonitoringMovedNode,
  RemoveDevice,
  TemperatureNode,
  WindowBreakDetection,
} from "src/components/Devices/DeviceSettings/DeviceSettingsNodes"
import { TDeviceCapability } from "src/data/devices/types/deviceTypes"
import { IEditFieldNode } from "src/data/editField/editFieldTypes"

const capabilityToSettingMap: {
  [key in TDeviceCapability]: IEditFieldNode["key"][]
} = {
  // General settings
  nightlight: [NightLight.key],
  window_break_detection: [WindowBreakDetection.key],
  alarm_recognition: [AlarmRecognition.key],
  signal_strength: [],
  battery_level: [],
  mount_status: [],
  motion_history: [],
  frequent_sensor_updates: [],
  wifi_reconfiguration: [],
  smoking_detection: [],
  water_leak_detection: [],
  water_leak_detection_gateway: [],

  // Temperature and humidity settings
  temperature: [TemperatureNode.key],
  temperature_threshold: [TemperatureNode.key],
  temperature_history: [TemperatureNode.key],

  humidity: [HumidityNode.key],
  humidity_threshold: [HumidityNode.key],
  humidity_history: [HumidityNode.key],

  // Noise monitoring settings
  sound_level: [NoiseMonitoringMovedNode.key],
  sound_level_threshold: [NoiseMonitoringMovedNode.key],
  sound_level_history: [NoiseMonitoringMovedNode.key],

  // Mould detection settings
  mould_index: [],
  mould_index_history: [],
}

export const alwaysDisplayedSettings = [
  DeviceAreaType.key,
  NightLight.key,
  HomeTransfer.key,
  RemoveDevice.key,
]

export function shouldDisplaySetting(
  settingKey: IEditFieldNode["key"],
  deviceCapabilities: TDeviceCapability[]
): boolean {
  // Always show certain settings
  if (alwaysDisplayedSettings.includes(settingKey)) {
    return true
  }

  // Check if any of the device capabilities map to this setting
  return deviceCapabilities.some((capability) => {
    const mappedSettings = capabilityToSettingMap[capability]
    return mappedSettings && mappedSettings.includes(settingKey)
  })
}
